import React from "react";

import { formatMs, formatNumber } from "utils/format";

import styles from "./style.module.scss";

function QueryDetailsStats({
  avgTime,
  callsPerMinute,
  avgTimeTrend,
  callsPerMinuteTrend,
  compareToggle,
}: {
  avgTime: number;
  callsPerMinute: number;
  avgTimeTrend?: React.ReactNode;
  callsPerMinuteTrend?: React.ReactNode;
  compareToggle?: React.ReactNode;
}) {
  return (
    <div className={styles.pageContext}>
      <div className={styles.pageContextStats}>
        <dl>
          <dt>Avg Time</dt>
          <dd>
            <div className={styles.statsNumber}>{formatMs(avgTime)}</div>
            {avgTimeTrend}
          </dd>
        </dl>
        <dl>
          <dt>Calls Per Minute</dt>
          <dd>
            <div className={styles.statsNumber}>
              {formatNumber(callsPerMinute, 2)} / min
            </div>
            {callsPerMinuteTrend}
          </dd>
        </dl>
      </div>
      {compareToggle && (
        <div className={styles.compareToggle}>{compareToggle}</div>
      )}
    </div>
  );
}

export default QueryDetailsStats;
